/**
 * Gift Finder Quiz — gift-finder.js
 * Impulse Theme v3 Compatible
 */

(function () {
  'use strict';

  function initGiftFinder(sectionId) {
    var cfg = window.GiftFinderConfig && window.GiftFinderConfig[sectionId];
    if (!cfg) return;

    var section     = document.getElementById('gift-finder-' + sectionId);
    if (!section) return;

    var hero        = document.getElementById('gf-hero-' + sectionId);
    var quizWrap    = document.getElementById('gf-quiz-' + sectionId);
    var progressBar = document.getElementById('gf-progress-' + sectionId);
    var stepLabel   = document.getElementById('gf-step-label-' + sectionId);
    var backBtn     = document.getElementById('gf-back-' + sectionId);
    var startBtn    = document.getElementById('gf-start-' + sectionId);
    var nameBlock   = document.getElementById('gf-name-' + sectionId);
    var nameInput   = document.getElementById('gf-name-input-' + sectionId);
    var nameNextBtn = document.getElementById('gf-name-next-' + sectionId);
    var nameSkipBtn = document.getElementById('gf-name-skip-' + sectionId);
    var resultBlock = document.getElementById('gf-result-' + sectionId);
    var greetingEl  = document.getElementById('gf-greeting-' + sectionId);
    var productsEl  = document.getElementById('gf-products-' + sectionId);
    var resultBtn   = document.getElementById('gf-result-btn-' + sectionId);
    var restartBtn  = document.getElementById('gf-restart-' + sectionId);

    var questionBlocks = Array.from(section.querySelectorAll('.gf-question-block'));
    var totalQuestions = questionBlocks.length;

    var state = { step: 0, userName: '', answers: {} };

    function stepToQIndex(step) {
      return step - (cfg.nameBlockEnabled ? 2 : 1);
    }

    function show(el) { if (el) el.style.display = 'block'; }
    function hide(el) { if (el) el.style.display = 'none'; }

    function hideAllPanels() {
      hide(nameBlock);
      questionBlocks.forEach(function (b) { hide(b); });
      hide(resultBlock);
    }

    function updateProgress() {
      var qIdx = stepToQIndex(state.step);
      var pct  = (qIdx >= 0 && totalQuestions > 0)
        ? Math.round(((qIdx + 1) / totalQuestions) * 100)
        : 0;
      if (progressBar) progressBar.style.width = pct + '%';
      if (stepLabel) {
        if (qIdx >= 0 && qIdx < totalQuestions) {
          stepLabel.textContent = 'Question ' + (qIdx + 1) + ' of ' + totalQuestions;
        } else {
          stepLabel.textContent = '';
        }
      }
    }

    function goToStep(step) {
      state.step = step;

      if (step === 0) {
        show(hero);
        hide(quizWrap);
        return;
      }

      hide(hero);
      show(quizWrap);
      hideAllPanels();
      updateProgress();

      if (backBtn) backBtn.style.display = step > 1 ? 'inline' : 'none';

      if (cfg.nameBlockEnabled && step === 1) {
        show(nameBlock);
        scrollToTop();
        return;
      }

      var qIdx = stepToQIndex(step);
      if (qIdx >= 0 && qIdx < totalQuestions) {
        var block = questionBlocks[qIdx];
        show(block);
        var saved = state.answers[qIdx];
        block.querySelectorAll('.gf-answer-item').forEach(function (item) {
          item.classList.toggle('is-selected', !!(saved && item.dataset.answer === saved.text));
        });
        refreshNextBtn(block, qIdx);
        scrollToTop();
        return;
      }

      if (backBtn) backBtn.style.display = 'none';
      show(resultBlock);
      renderResult();
      scrollToTop();
    }

    function scrollToTop() {
      if (!cfg.scrollToQuiz) return;
      setTimeout(function () {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 60);
    }

    function next() { goToStep(state.step + 1); }
    function back() { if (state.step > 0) goToStep(state.step - 1); }

    function refreshNextBtn(block, qIdx) {
      var btn = block.querySelector('.gf-btn--q-next');
      if (!btn) return;
      var has = !!state.answers[qIdx];
      btn.disabled      = !has;
      btn.style.opacity = has ? '1' : '0.45';
      btn.style.cursor  = has ? 'pointer' : 'not-allowed';
    }

    questionBlocks.forEach(function (block, qIdx) {
      var items = block.querySelectorAll('.gf-answer-item');
      items.forEach(function (item) {
        item.addEventListener('click', function () {
          items.forEach(function (i) { i.classList.remove('is-selected'); });
          item.classList.add('is-selected');
          state.answers[qIdx] = {
            text:       item.dataset.answer     || '',
            collection: item.dataset.collection || ''
          };
          refreshNextBtn(block, qIdx);
        });
      });

      var nBtn = block.querySelector('.gf-btn--q-next');
      if (nBtn) {
        nBtn.addEventListener('click', function () {
          if (!nBtn.disabled) next();
        });
      }
    });

    if (startBtn) startBtn.addEventListener('click', function () { next(); });

    if (nameNextBtn) {
      nameNextBtn.addEventListener('click', function () {
        if (nameInput) state.userName = nameInput.value.trim();
        next();
      });
    }
    if (nameSkipBtn) {
      nameSkipBtn.addEventListener('click', function () {
        state.userName = '';
        next();
      });
    }
    if (nameInput) {
      nameInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { state.userName = nameInput.value.trim(); next(); }
      });
    }

    if (backBtn) backBtn.addEventListener('click', back);

    if (restartBtn) {
      restartBtn.addEventListener('click', function () {
        state = { step: 0, userName: '', answers: {} };
        if (nameInput) nameInput.value = '';
        questionBlocks.forEach(function (block) {
          block.querySelectorAll('.gf-answer-item').forEach(function (i) {
            i.classList.remove('is-selected');
          });
          var nb = block.querySelector('.gf-btn--q-next');
          if (nb) { nb.disabled = true; nb.style.opacity = '0.45'; }
        });
        goToStep(0);
      });
    }

    // ── Result rendering ─────────────────────────────────────────────────────
    function renderResult() {
      // Personalized, exciting headings
      var personalized = [
        'Handpicked just for NAME_PLACEHOLDER',
        'NAME_PLACEHOLDER, we found your perfect match',
        'Made for NAME_PLACEHOLDER with love',
        'NAME_PLACEHOLDER, these picks are curated only for you',
        'A special collection for NAME_PLACEHOLDER'
      ];
      var generic = [
        'Handpicked matches from our collection',
        'We found the perfect gifts for you',
        'Your curated gift collection is ready',
        'These picks match your vibe perfectly',
        'Specially selected just for you'
      ];

      var withNameTpl = (cfg.greetingWithName && cfg.greetingWithName.length)
        ? cfg.greetingWithName
        : personalized[Math.floor(Math.random() * personalized.length)];
      var noNameTpl = (cfg.greetingNoName && cfg.greetingNoName.length)
        ? cfg.greetingNoName
        : generic[Math.floor(Math.random() * generic.length)];

      if (greetingEl) {
        greetingEl.textContent = state.userName
          ? withNameTpl.replace('NAME_PLACEHOLDER', state.userName)
          : noNameTpl;
      }

      var tags = [];
      var lastCol = '';
      Object.keys(state.answers).forEach(function (i) {
        var a = state.answers[i];
        if (a && a.text)       tags.push(a.text.toLowerCase());
        if (a && a.collection && a.collection !== 'none') lastCol = a.collection;
      });

      if (cfg.resultType === 'collection' && lastCol) {
        fetchByCollection(lastCol);
      } else {
        fetchByTags(tags);
      }
    }

    // ── Smart Multi-Phase Matching ──────────────────────────────────────────
    // Strategy: Fetch up to 250 products once, then SCORE each product by how well
    // it matches user's selected tags across:
    //   1. Product tags (strongest signal)
    //   2. Product title keywords
    //   3. Product type & vendor
    //   4. Product description
    //   5. Word stemming (moms vs mom vs mother)
    // Products with highest scores show first.

    function fetchByTags(keywords) {
      if (!keywords.length) { showNoProducts(); return; }

      // Normalize user keywords: lowercase, split multi-word phrases, stem common suffixes
      var userKeywords = normalizeKeywords(keywords);

      fetch('/products.json?limit=250')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var all = data.products || [];
          if (!all.length) { showNoProducts(); return; }

          // Score every product
          var scored = all.map(function (p) {
            return { product: p, score: scoreProduct(p, userKeywords) };
          });

          // Filter out zero-score ones
          var matches = scored.filter(function (s) { return s.score > 0; });

          // Sort by score descending
          matches.sort(function (a, b) { return b.score - a.score; });

          // If we still have nothing, show top bestsellers (first 8 products)
          if (!matches.length) {
            renderProductsJson(all.slice(0, 8));
            return;
          }

          // Show top 8 highest-scoring matches
          var topProducts = matches.slice(0, 8).map(function (s) { return s.product; });
          renderProductsJson(topProducts);
        })
        .catch(showNoProducts);
    }

    // Break down user's selected answers into searchable keywords
    // E.g. "Mothers Day" -> ["mothers", "day", "mother", "mom", "mothers-day"]
    function normalizeKeywords(rawKeywords) {
      var result = [];
      rawKeywords.forEach(function (kw) {
        var lc = String(kw).toLowerCase().trim();
        if (!lc) return;

        // Add original phrase
        result.push(lc);

        // Add hyphenated version: "mothers day" -> "mothers-day"
        if (lc.indexOf(' ') !== -1) {
          result.push(lc.replace(/\s+/g, '-'));
          // Split each word as separate keyword too
          lc.split(/\s+/).forEach(function (w) {
            if (w.length > 2) result.push(w);
          });
        }

        // Stemming: add root forms for better matching
        // mothers -> mother, kids -> kid, gifts -> gift, etc.
        if (lc.length > 3 && lc.slice(-1) === 's' && lc.slice(-2) !== 'ss') {
          result.push(lc.slice(0, -1)); // remove trailing 's'
        }
        // Add common synonyms
        var synonyms = {
          'mom': ['mother', 'mommy', 'mama'],
          'mother': ['mom', 'mommy', 'mama'],
          'dad': ['father', 'daddy', 'papa'],
          'father': ['dad', 'daddy', 'papa'],
          'mothers day': ['mothers-day', 'mother', 'mom'],
          'fathers day': ['fathers-day', 'father', 'dad'],
          'girlfriend': ['gf', 'for-her', 'woman'],
          'boyfriend': ['bf', 'for-him', 'man'],
          'wife': ['for-her', 'spouse', 'couple'],
          'husband': ['for-him', 'spouse', 'couple'],
          'nurse': ['nursing', 'rn', 'medical', 'healthcare'],
          'doctor': ['dr', 'md', 'physician', 'medical'],
          'teacher': ['professor', 'educator', 'teaching'],
          'birthday': ['bday', 'birth-day', 'happy-birthday'],
          'anniversary': ['anniv', 'wedding-anniversary'],
          'graduation': ['grad', 'graduate', 'graduating'],
          'retirement': ['retire', 'retiring', 'retired'],
          'floral': ['flower', 'flowers', 'botanical', 'wildflower'],
          'elegant': ['classy', 'sophisticated', 'premium']
        };
        if (synonyms[lc]) {
          synonyms[lc].forEach(function (s) { result.push(s); });
        }
      });

      // Deduplicate
      var seen = {};
      return result.filter(function (k) {
        if (seen[k]) return false;
        seen[k] = true;
        return true;
      });
    }

    // Score how well a product matches the user's keywords.
    // Higher score = better match.
    function scoreProduct(product, keywords) {
      var score = 0;

      // Build searchable text blobs for the product
      var pTags = (product.tags || []).map(function (t) { return String(t).toLowerCase(); });
      var pTitle = String(product.title || '').toLowerCase();
      var pType  = String(product.product_type || '').toLowerCase();
      var pVendor = String(product.vendor || '').toLowerCase();
      var pDesc  = String(product.body_html || '').toLowerCase().replace(/<[^>]+>/g, ' ');
      var pHandle = String(product.handle || '').toLowerCase();

      keywords.forEach(function (kw) {
        // 1. EXACT tag match = strongest signal (10 points)
        if (pTags.indexOf(kw) !== -1) {
          score += 10;
          return;
        }

        // 2. Partial tag match (tag contains keyword) = good signal (6 points)
        var tagPartial = pTags.some(function (t) {
          return t.indexOf(kw) !== -1 || kw.indexOf(t) !== -1;
        });
        if (tagPartial) {
          score += 6;
          return;
        }

        // 3. Title contains keyword as whole word = strong signal (7 points)
        var titleWordRegex = new RegExp('\\b' + escapeRegex(kw) + '\\b', 'i');
        if (titleWordRegex.test(pTitle)) {
          score += 7;
          return;
        }

        // 4. Title contains keyword as substring (5 points)
        if (pTitle.indexOf(kw) !== -1) {
          score += 5;
          return;
        }

        // 5. Handle contains keyword (product URL slug) (4 points)
        if (pHandle.indexOf(kw) !== -1) {
          score += 4;
          return;
        }

        // 6. Product type or vendor matches (3 points)
        if (pType.indexOf(kw) !== -1 || pVendor.indexOf(kw) !== -1) {
          score += 3;
          return;
        }

        // 7. Description mentions keyword (weak signal, 1 point)
        if (pDesc.indexOf(kw) !== -1) {
          score += 1;
        }
      });

      return score;
    }

    function escapeRegex(s) {
      return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function fetchByCollection(handle) {
      fetch('/collections/' + handle + '/products.json?limit=8')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = data.products || [];
          products.length ? renderProductsJson(products) : showNoProducts();
        })
        .catch(showNoProducts);
    }

    // ── Render: products.json format (full data with images + variants) ──────
    function renderProductsJson(products) {
      if (!productsEl) return;
      productsEl.innerHTML = '';
      products.forEach(function (p) {
        var imgSrc = '';
        if (p.images && p.images.length) {
          imgSrc = p.images[0].src || p.images[0];
        } else if (p.featured_image) {
          imgSrc = typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.src;
        }

        var price = 0, compareAt = 0;
        if (p.variants && p.variants.length) {
          price     = parseFloat(p.variants[0].price) || 0;
          compareAt = parseFloat(p.variants[0].compare_at_price) || 0;
        }

        productsEl.appendChild(buildCard(
          p.title,
          imgSrc,
          price,
          compareAt,
          '/products/' + p.handle
        ));
      });
      updateResultBtnHref();
    }

    // Render search.json results (similar but price may be in different field)
    function renderProductsFull(products) {
      if (!productsEl) return;
      productsEl.innerHTML = '';
      products.forEach(function (p) {
        var imgSrc = (p.images && p.images[0] && (p.images[0].src || p.images[0])) ||
                     p.featured_image || '';
        var price = 0, compareAt = 0;
        if (p.variants && p.variants[0]) {
          price     = parseFloat(p.variants[0].price) || 0;
          compareAt = parseFloat(p.variants[0].compare_at_price) || 0;
        } else {
          price     = parseFloat(p.price) || 0;
          compareAt = parseFloat(p.compare_at_price) || 0;
        }
        productsEl.appendChild(buildCard(
          p.title, imgSrc, price, compareAt,
          '/products/' + p.handle
        ));
      });
      updateResultBtnHref();
    }

    function updateResultBtnHref() {
      if (!resultBtn) return;
      var lastCol = '';
      Object.values(state.answers).forEach(function (a) { if (a.collection && a.collection !== 'none') lastCol = a.collection; });
      if (cfg.resultType === 'collection' && lastCol) {
        resultBtn.href = '/collections/' + lastCol;
      } else {
        var q = Object.values(state.answers).map(function (a) { return a.text; }).filter(Boolean).join(' ');
        resultBtn.href = '/search?type=product&q=' + encodeURIComponent(q);
      }
    }

    // ── Product card with real image + price + compare-at + savings ──────────
    function buildCard(title, imgSrc, price, compareAt, url) {
      var a = document.createElement('a');
      a.href = url; a.className = 'gf-product-card';

      // Image
      var imgWrap = document.createElement('div');
      imgWrap.className = 'gf-product-card__img';

      if (imgSrc) {
        // Ensure Shopify CDN URL has https:// prefix
        if (imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
        var img = document.createElement('img');
        img.src = imgSrc; img.alt = title; img.loading = 'lazy';
        img.onerror = function () {
          img.style.display = 'none';
          var ph = document.createElement('div');
          ph.className = 'gf-product-card__img-placeholder';
          ph.textContent = '🎁';
          imgWrap.appendChild(ph);
        };
        imgWrap.appendChild(img);
      } else {
        var ph = document.createElement('div');
        ph.className = 'gf-product-card__img-placeholder';
        ph.textContent = '🎁';
        imgWrap.appendChild(ph);
      }

      // Savings badge (if compare price > actual price)
      if (compareAt > price && price > 0) {
        var savePct = Math.round(((compareAt - price) / compareAt) * 100);
        var badge = document.createElement('div');
        badge.className = 'gf-save-badge';
        badge.textContent = '-' + savePct + '%';
        imgWrap.appendChild(badge);
      }

      // Info
      var info = document.createElement('div');
      info.className = 'gf-product-card__info';

      var t = document.createElement('p');
      t.className = 'gf-product-card__title'; t.textContent = title;

      var priceRow = document.createElement('div');
      priceRow.className = 'gf-price-row';

      var priceEl = document.createElement('span');
      priceEl.className = 'gf-product-card__price';
      priceEl.textContent = formatPrice(price);
      priceRow.appendChild(priceEl);

      if (compareAt > price && price > 0) {
        var compareEl = document.createElement('span');
        compareEl.className = 'gf-product-card__compare';
        compareEl.textContent = formatPrice(compareAt);
        priceRow.appendChild(compareEl);

        var saveText = document.createElement('div');
        saveText.className = 'gf-save-text';
        saveText.textContent = 'Save ' + formatPrice(compareAt - price);
        info.appendChild(t);
        info.appendChild(priceRow);
        info.appendChild(saveText);
      } else {
        info.appendChild(t);
        info.appendChild(priceRow);
      }

      a.appendChild(imgWrap); a.appendChild(info);
      return a;
    }

    function showNoProducts() {
      if (productsEl) productsEl.innerHTML =
        '<div class="gf-no-products">No products found. Try a different combination!</div>';
    }

    // Price formatter — amount is in currency units (not cents) from products.json
    function formatPrice(amount) {
      if (!amount || amount <= 0) return '';
      amount = parseFloat(amount);

      // Shopify's formatMoney expects cents — convert
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        try {
          return Shopify.formatMoney(amount * 100);
        } catch (e) { /* fall through */ }
      }

      // Currency-aware fallback
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PKR';
      var symbols = { PKR: 'Rs. ', USD: '$', EUR: '€', GBP: '£', INR: '₹', AED: 'AED ', SAR: 'SAR ' };
      var sym = symbols[currency] || currency + ' ';
      return sym + amount.toLocaleString('en-US', { maximumFractionDigits: 2 });
    }

    goToStep(0);
  }

  function boot() {
    Object.keys(window.GiftFinderConfig || {}).forEach(function (id) {
      initGiftFinder(id);
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();

  document.addEventListener('shopify:section:load', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (id && window.GiftFinderConfig && window.GiftFinderConfig[id]) initGiftFinder(id);
  });

})();